import { CONTEST_SETTING } from '../../utils/station/settings';
import { useStationMode } from './useStationMode';
import { useStationSetting } from './useStationSetting';

/**
 * `?contest=true` turns the contest flow on for the station, `?contest=<tag>`
 * (e.g. `ces2027`) also tags every entry so different events can be told apart.
 * `?contest=false` turns it off again.
 */
export const STATION_CONTEST_URL_PARAM = CONTEST_SETTING.param;
export const STATION_CONTEST_STORAGE_KEY = CONTEST_SETTING.storageKey;

export interface StationContestConfig {
  isContestMode: boolean;
  contestId: string | null;
}

const DISABLED: StationContestConfig = {
  isContestMode: false,
  contestId: null,
};

/** Contest flow config, only ever enabled while station mode is on */
export function useStationContest(): StationContestConfig {
  const isStationMode = useStationMode();
  const contest = useStationSetting(CONTEST_SETTING);

  if (!isStationMode || !contest) return DISABLED;

  return {
    isContestMode: true,
    contestId: contest === 'true' ? null : contest,
  };
}
